// extracted by mini-css-extract-plugin
export default {"body":"style_body__Zovwi","loader":"style_loader__We6G5","pgfill":"style_pgfill__XvUno"};